import React from 'react';
import { Navigate } from 'react-router-dom';

import { SettingsFacilitiesTable } from './SettingsFacilitiesTable';
import { Typography } from 'packages/common-frontend/components/Typography';
import { useCreditFacilitiesOrThrow } from '~/contexts/CreditFacilitiesProvider';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';

// Fragments
const RouteBase = () => {
  const { facilities } = useCreditFacilitiesOrThrow();
  return (
    <>
      <Typography variant="page-title">Facilities</Typography>
      <SettingsFacilitiesTable creditFacilities={facilities} />
    </>
  );
};

// Exports
export const Route = () => (
  <RouteErrorBoundary
    fallback={({ message, showErrorToast }) => {
      showErrorToast(message);
      return <Navigate to="/settings" />;
    }}
  >
    <RouteBase />
  </RouteErrorBoundary>
);
